import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import Pillar1 from './pages/Pillar1';
import Pillar2 from './pages/Pillar2';
import Pillar3 from './pages/Pillar3';
import Pillar4 from './pages/Pillar4';
import Pillar5 from './pages/Pillar5';
import CnPillar1 from './pages/country/CnPillar1';
import CnPillar2 from './pages/country/CnPillar2';
import CnPillar3 from './pages/country/CnPillar3';
import CnPillar4 from './pages/country/CnPillar4';
import CnPillar5 from './pages/country/CnPillar5';


function App() {
  let crrURL = window.location.href;
  if(crrURL.toLowerCase().search("gbl")>0)
  {
    console.log(crrURL);
    return (
      <Router>
        <Switch>
          <div className="App">
          <Route path="/:iso" exact component={Pillar1} />
            <Route path="/pillar2/:iso" exact component={Pillar2} />
            <Route path="/pillar3/:iso" exact component={Pillar3} />
            <Route path="/pillar4/:iso" exact component={Pillar4} />
            <Route path="/pillar5/:iso" exact component={Pillar5} />

          </div>
        </Switch>
      </Router>
    );
    }
    if(crrURL.toLowerCase().search("gbl")<0)
    return (
      <Router>
        <Switch>
          <div className="App">
            <Route path="/pillar1/:iso" component={CnPillar1} />
            <Route path="/pillar2/:iso" component={CnPillar2} />
            <Route path="/pillar3/:iso" component={CnPillar3} />
            <Route path="/pillar4/:iso" component={CnPillar4} />
            <Route path="/pillar5/:iso" component={CnPillar5} />
  
          </div>
        </Switch>
      </Router>
    );
    return (
      <Router>
        <Switch>
          <div className="App">
            <Route path="/:iso" exact component={Pillar1} />
            <Route path="/pillar2/:iso" exact component={Pillar2} />
            <Route path="/pillar3/:iso" exact component={Pillar3} />
            <Route path="/pillar4/:iso" exact component={Pillar4} />
            <Route path="/pillar5/:iso" exact component={Pillar5} />

          </div>
        </Switch>
      </Router>
    );

  }


export default App;
